'use strict'

import RundownItemBase from '../../rundown/controllers/rundown_item_base_ctrl'

export default class CampaignItemCtrl extends RundownItemBase {

    constructor (
        Contact,
        $http,
        Item,
        itemData,
        $rootScope,
        $scope,
        $state,
        $stateParams,
        $timeout,
        widgets,
    ) {
        super(
            Contact,
            $http,
            $scope,
            $state,
            $timeout,
        )

        this.Item = Item
        this.itemData = itemData
        this.$rootScope = $rootScope
        this.$stateParams = $stateParams
        this.widgets = widgets

        this.editor = null
        this.contactSearchData = ['']

        //item data
        this.model_type_id_original = 0

        //If connected contact is updated, update information in item view
        $scope.$on('item_contact_updated', this.contactUpdate.bind(this))

        itemData.subscribe('item', $scope, () => {
            this.setFormData(itemData.getItemObj())
        })

        // if (!itemData.getItemObj()) {
        //     $state.go('^');
        // }

        this.fetch().then(() => {
            let unRegister = this.$scope.$watch(() => {
                return this.itemData.getItemObj().model_type_id
            }, value => {
                if (value) {
                    unRegister()
                    this.originalData = angular.copy(this.itemData.getItemObj())
                }
            })
        })
    }

    fetch () {
        return new Promise(resolve => {
            this.getModelTypes().then(() => {
                this.$timeout(() => {
                    resolve()
                    this.initView()
                })
            })
        })
    }

    initView () {
        this.setFormData(this.itemData.getItemObj())

        this.loaded = true
        this.detailsLoaded = true
        this.$scope.$apply()
    }

    setFormData (data) {
        this.formdata = data

        if (!this.formdata.model_type_id) {
            this.formdata.model_type_id = this.customFieldsRaw[0].id
        }

        if (!this.formdata.tags) {
            this.formdata.tags = []
        }
        if (!this.formdata.duration) {
            this.formdata.duration = 60
        }
        if (!this.formdata.title) {
            this.formdata.title = this.$stateParams.title
        }
    }

    blockLocalChips ($chip) {
        return $chip //not used in campaign
    }

    save () {
        this.widgets.saveWidgetsForTypeId('item-' + this.$state.params.itemId).then(() => {
            this.itemData.setItemObj(this.formdata)
            this.originalData = angular.copy(this.formdata)
            this.itemData.notify('campaign')

            this.backToCampaign()

        })
    }

    backToCampaign () {
        let pageURL = window.location.href
        let lastURLSegment = pageURL.substr(pageURL.lastIndexOf('/') + 1)

        if (lastURLSegment === 'item') {
            if (this.originalData) {
                this.itemData.setItemObj(this.originalData)
            }
            this.$state.go('^')
        } else {
            this.$state.go('^.^')
        }

    }

    contactDelete(ev, index) {
        ev.preventDefault();
        this.formdata.contacts.splice(index, 1);
    }

}

CampaignItemCtrl.$inject = [
    'Contact',
    '$http',
    'Item',
    'itemData',
    '$rootScope',
    '$scope',
    '$state',
    '$stateParams',
    '$timeout',
    'widgets'
]
